var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9085_328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9085_328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18.9996V8.99961C3 8.44961 3.19583 7.97878 3.5875 7.58711C3.97917 7.19544 4.45 6.99961 5 6.99961H9V5.82461C9 5.55794 9.05 5.30378 9.15 5.06211C9.25 4.82044 9.39167 4.60794 9.575 4.42461L10.575 3.42461C10.9583 3.04128 11.4333 2.84961 12 2.84961C12.5667 2.84961 13.0417 3.04128 13.425 3.42461L14.425 4.42461C14.6083 4.60794 14.75 4.82044 14.85 5.06211C14.95 5.30378 15 5.55794 15 5.82461V10.9996H19C19.55 10.9996 20.0208 11.1954 20.4125 11.5871C20.8042 11.9788 21 12.4496 21 12.9996V18.9996C21 19.5496 20.8042 20.0204 20.4125 20.4121C20.0208 20.8038 19.55 20.9996 19 20.9996H5C4.45 20.9996 3.97917 20.8038 3.5875 20.4121C3.19583 20.0204 3 19.5496 3 18.9996ZM5 18.9996H7V16.9996H5V18.9996ZM5 14.9996H7V12.9996H5V14.9996ZM5 10.9996H7V8.99961H5V10.9996ZM11 18.9996H13V16.9996H11V18.9996ZM11 14.9996H13V12.9996H11V14.9996ZM11 10.9996H13V8.99961H11V10.9996ZM11 6.99961H13V4.99961H11V6.99961ZM17 18.9996H19V16.9996H17V18.9996ZM17 14.9996H19V12.9996H17V14.9996Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.a747e972008e3c76ea600e4dd84065de.svg";
export { ForwardRef as ReactComponent };